// @ts-nocheck

import * as Types from '../../../../../../graphql/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { gql } from '@apollo/client';
export type ValidateImporterColumnQueryVariables = Types.Exact<{
  input: Types.ReferenceIdColumnValidationQueryModelInput;
}>;

export type ValidateImporterColumnQuery = {
  validateReferenceIdsColumn: { validations?: Array<ValidationsFragment | null> | null };
};

export type ValidationsFragment = {
  urn?: string | null;
  index?: number | null;
  result?: { valid?: boolean | null; message?: string | null } | null;
};

export const ValidationsFragmentDoc = gql`
    fragment Validations on ReferenceIdValidationModel {
  urn
  index
  result {
    valid
    message
  }
}
    ` as unknown as DocumentNode<ValidationsFragment, unknown>;
export const ValidateImporterColumnDocument = gql`
    query ValidateImporterColumn($input: ReferenceIdColumnValidationQueryModelInput!) {
  validateReferenceIdsColumn(input: $input) {
    validations {
      ...Validations
    }
  }
}
    ${ValidationsFragmentDoc}` as unknown as DocumentNode<
  ValidateImporterColumnQuery,
  ValidateImporterColumnQueryVariables
>;
